import { render, staticRenderFns } from "./RukoGarantTen.vue?vue&type=template&id=46dcedf0&"
import script from "./RukoGarantTen.vue?vue&type=script&lang=js&"
export * from "./RukoGarantTen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports